(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:pinMeOnHorizontalScroll
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <pin-me-on-horizontal-scroll></pin-me-on-horizontal-scroll>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('pinMeOnHorizontalScroll', pinMeOnHorizontalScroll);

    function pinMeOnHorizontalScroll(EventManagerService) {
        return {
            restrict: 'A',
            replace: false,
            controllerAs: 'pinMeOnHorizontalScroll',
            link: function (scope, element, attrs) {
                var elementClientRect = angular.element(element)[0].getBoundingClientRect(),
                    parentClientRect = angular.element(element.parent())[0].getBoundingClientRect(),
                    originalElementTop = elementClientRect.top - parentClientRect.top,
                    originalElementWidth = elementClientRect.width,
                    originalElementLeft = elementClientRect.left - parentClientRect.left,
                    originalPositionProperty = element.css('position'),
                    dummyElement = angular.element('<div class="dummy-item">');

                dummyElement.addClass(element.attr('class'));
                dummyElement.css({'width': '0px', 'height': '0px', 'display': 'none'});
                element.after(dummyElement);

                EventManagerService.registerEventListener(EventManagerService.EVENT.SCROLL.SCROLL_LEFT_CHANGE, function (param) {
                    if (param > 0) {
                        dummyElement.css({'width': originalElementWidth + 'px', 'height': '1px', 'display': 'block'});
                        element.addClass('pin-on-horizontal-scroll');

                        element.css({
                            'position': 'absolute',
                            'top': originalElementTop + 'px',
                            'left': (originalElementLeft + param) + 'px',
                            'z-index' : 10
                        });

                    } else {
                        dummyElement.css({'width': '0px', 'height': '0px', 'display': 'none'});
                        element.css({
                            'position': originalPositionProperty
                        });
                        element.removeClass('pin-on-horizontal-scroll');
                    }
                })

            }
        };
    }
}());
